import { render, staticRenderFns } from "./UserInstructions.vue?vue&type=template&id=580a1ec0"
import script from "./UserInstructions.vue?vue&type=script&lang=js"
export * from "./UserInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports